/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProductAnnouncement } from './ProductAnnouncement';
import {
    ProductAnnouncementFromJSON,
    ProductAnnouncementFromJSONTyped,
    ProductAnnouncementToJSON,
    ProductAnnouncementToJSONTyped,
} from './ProductAnnouncement';

/**
 * 
 * @export
 * @interface ProductAnnouncements
 */
export interface ProductAnnouncements {
    /**
     * 
     * @type {Array<ProductAnnouncement>}
     * @memberof ProductAnnouncements
     */
    items: Array<ProductAnnouncement>;
}

/**
 * Check if a given object implements the ProductAnnouncements interface.
 */
export function instanceOfProductAnnouncements(value: object): value is ProductAnnouncements {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function ProductAnnouncementsFromJSON(json: any): ProductAnnouncements {
    return ProductAnnouncementsFromJSONTyped(json, false);
}

export function ProductAnnouncementsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductAnnouncements {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ProductAnnouncementFromJSON)),
    };
}

export function ProductAnnouncementsToJSON(json: any): ProductAnnouncements {
    return ProductAnnouncementsToJSONTyped(json, false);
}

export function ProductAnnouncementsToJSONTyped(value?: ProductAnnouncements | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(ProductAnnouncementToJSON)),
    };
}

